import React, { useState, useEffect } from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

import './Footer.css';

function Footer() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    // Fetch settings for social links
    fetch('/api/admin/settings.php')
      .then(res => res.json())
      .then(data => {
        if (data.success) setSettings(data.data);
      })
      .catch(err => console.error('Error fetching settings:', err));
  }, []);

 const socialLinks = [

    { key: 'facebook_url', label: 'Facebook', icon: FaFacebookF, color: '#1877f2' },

    { key: 'instagram_url', label: 'Instagram', icon: FaInstagram, color: '#e4405f' },

    { key: 'twitter_url', label: 'Twitter', icon: FaTwitter, color: '#1da1f2' },

    { key: 'youtube_url', label: 'YouTube', icon: FaYoutube, color: '#ff0000' },

  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <div className="footer-logo">
              <img src="/logo.png" alt="Heaven Green Infra. Landscape" className="footer-logo-image" />
            </div>
            <p className="footer-description">
              Professional landscaping services dedicated to transforming outdoor spaces into beautiful, sustainable environments.
            </p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/testimonials">Testimonials</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-services">
            <h4>Our Services</h4>
            <ul>
              <li>Garden Design</li>
              <li>Lawn Maintenance</li>
              <li>Hardscaping</li>
              <li>Irrigation Systems</li>
              <li>Landscape Lighting</li>
              <li>Tree Planting</li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <strong>Address:</strong><br />
                Near Maa Sharda Public School,<br />
                Main Road Kathadih, Mathpurena,<br />
                Raipur
              </li>
              <li>
                <strong>Phone:</strong> <a href="tel:+919981206128">+91 99812 06128</a>, <a href="tel:+916264573743">+91 62645 73743</a>
              </li>
              <li>
                <strong>Email:</strong><br />
                <a href="mailto:heavengreeninfra0@gmail.com">heavengreeninfra0@gmail.com</a><br />
                <a href="mailto:heavengreenprojects@gmail.com">heavengreenprojects@gmail.com</a><br />
                <a href="mailto:sahurajeshkumar84@gmail.com">sahurajeshkumar84@gmail.com</a>
              </li>
              <li>
                <strong>Business Hours:</strong><br />
                Mon - Sat: 10:00 AM - 5:00 PM<br />
                Sun: Closed
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} {settings.site_name || 'Heaven Green Infra. Landscape'}. All rights reserved.
            {' '}
            <a href="/admin/login" className="footer-admin-link" target="_blank" rel="noopener noreferrer">Admin</a>
          </p>
          <div className="footer-social">
            {socialLinks.map((social) => (
              settings[social.key] && (
                <a 
                  key={social.key}
                  href={settings[social.key]} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  {social.icon}
                </a>
              )
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;